export const API_BASE_URL = (process.env.NODE_ENV === 'production')? "https://pro.qushi.io/api/" : "http://127.0.0.1:8000/api/"
export const BASE_URL = "https://pro.qushi.io"
export const GAME_URL = "https://app.qushi.io/contest"